var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-slide"},[_c(_vm.renderComponent,{tag:"component",attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }